import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withEditFunctionality } from 'components/Portfolio/PortfolioAbout/components/hoc/withEditFunctionality';
import SkillsSelector from 'components/Shared/Selectors/SkillsSelector';
import {
  isFreelanceGigSkill,
  sortSkillsByLevel,
} from 'helpers/portfolioLayout';
import SkillRing from './SkillRing';
import styles from './Skills.module.scss';

const DESKTOP_LIMIT = 12;
const PHONE_LIMIT = 8;

@withEditFunctionality
export default class Skills extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    editMode: PropTypes.bool,
    updateData: PropTypes.func,
    loggedInUser: PropTypes.object,
    isOwner: PropTypes.bool,
  };

  state = {
    showAll: false,
  };

  updateSkills(newSkills) {
    const { data: skills, updateData: updateSkills } = this.props;
    const updatedSkills = [];
    const cache = {};

    // Save the old skill names in the cache
    for (const skill of skills) cache[skill.name] = skill;

    for (const newSkill of newSkills) {
      // If the skill already exists
      if (cache[newSkill.label]) {
        // Save the old skill object
        updatedSkills.push(cache[newSkill.label]);
      } else {
        // Otherwise create a new skill object
        updatedSkills.push({ name: newSkill.label, experience: 0 });
      }
    }

    updateSkills(updatedSkills);
  }

  getItemClassName(index) {
    if (this.state.showAll) {
      return '';
    }
    if (index >= DESKTOP_LIMIT) {
      return styles.collapsed;
    }
    if (index >= PHONE_LIMIT) {
      return styles.collapsedOnPhone;
    }
    return '';
  }

  render() {
    const { data, editMode, loggedInUser, isOwner } = this.props;
    const { showAll } = this.state;

    if (editMode) {
      return (
        <SkillsSelector
          existing={data}
          onSelect={(selected) => this.updateSkills(selected)}
          style={{ width: '100%' }}
        />
      );
    }

    // Freelance Gig is an opt-in flag, not a skill clients should see.
    const skills = sortSkillsByLevel(
      isOwner ? data : data.filter((skill) => !isFreelanceGigSkill(skill))
    );

    if (skills.length === 0) return null;

    const userType = loggedInUser ? loggedInUser.type : 'guest';
    const showAllClass = skills.length > DESKTOP_LIMIT ? '' : styles.phoneOnly;

    return (
      <div className={styles.container}>
        {isOwner && (
          <p className={styles.hint}>
            Add the Freelance Gig skill to opt in for non-specialised jobs.
          </p>
        )}
        <ul className={styles.grid}>
          {skills.map((skill, index) => (
            <SkillRing
              key={skill.id || skill.name}
              skill={skill}
              userType={userType}
              className={this.getItemClassName(index)}
            />
          ))}
        </ul>
        {skills.length > PHONE_LIMIT && (
          <button
            type="button"
            className={`${styles.showAll} ${showAll ? '' : showAllClass}`}
            onClick={() => this.setState({ showAll: !showAll })}
            aria-expanded={showAll}
          >
            {showAll ? 'Show fewer skills' : `Show all ${skills.length} skills`}
          </button>
        )}
      </div>
    );
  }
}
